import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import isEmpty from 'lodash/isEmpty';
import { FONT_FAMILY_MAIN } from '../../main-app/theme';

const InputHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
`;

const Label = styled.label`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.57;
  letter-spacing: 0.3px;
  margin-bottom: 0;
  font-family: ${FONT_FAMILY_MAIN};
  color: ${(props) => (props.valid === false ? '#f74656' : props.labelTextColor)};
`;

const Link = styled.a`
  font-size: 12px;
  line-height: 1.33;
  letter-spacing: -0.1px;
  text-align: right;
  color: #4a90e2;
  text-decoration: none;
`;

const OptionalText = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.57;
  letter-spacing: 0.3px;
  color: #ccd0d4;
`;

const FieldLabel = ({
  label, optionalLink, optionalText, valid, labelTextColor,
}) => {
  const shouldRenderLink = optionalText && optionalLink;
  const shouldRenderText = optionalText;
  const shouldRenderInputHeader = !isEmpty(label) || shouldRenderLink || shouldRenderText;

  return (
    shouldRenderInputHeader && (
      <InputHeader>
        <Label labelTextColor={labelTextColor} valid={valid}>{label}</Label>
        {(shouldRenderLink && (
          /* Force link to be last in keyboard navigation */
          /* eslint-disable-next-line jsx-a11y/tabindex-no-positive */
          <Link tabIndex="50" href={optionalLink}>
            {optionalText}
          </Link>
        ))
        || (shouldRenderText && <OptionalText>{optionalText}</OptionalText>)}
      </InputHeader>
    )
  );
};

FieldLabel.propTypes = {
  label: PropTypes.string,
  optionalLink: PropTypes.string,
  optionalText: PropTypes.string,
  valid: PropTypes.bool,
  labelTextColor: PropTypes.string,
};

FieldLabel.defaultProps = {
  label: '',
  optionalLink: '',
  optionalText: '',
  valid: null,
  labelTextColor: '#354354',
};

export default FieldLabel;
